import type { StripControlledProperties } from '~/shared/forms/types';
import { useFormField } from '~/shared/forms/useFormField';
import { DatePickerField, type DatePickerFieldProps } from '../../base-fields/DatePickerField';

export function DatePickerFormField(props: StripControlledProperties<Omit<DatePickerFieldProps, 'validate'>>) {
	const fieldProps = useFormField<Date | null>(props);

	return <DatePickerField {...props} {...fieldProps} granularity="day" />;
}
